export type EmailFlow =
  | "ackEmail"
  | "ratedAgeRequest"
  | "requestForMaterials"
  | "picker";

export const getEmailFlowToOpen = (
  canSendAckEmail: boolean,
  canSendRatedAgeRequest: boolean,
  canSendRequestForMaterials: boolean,
): EmailFlow => {
  const available: EmailFlow[] = [];
  if (canSendAckEmail) {
    available.push("ackEmail");
  }
  if (canSendRatedAgeRequest) {
    available.push("ratedAgeRequest");
  }
  if (canSendRequestForMaterials) {
    available.push("requestForMaterials");
  }

  return available.length === 1 ? available[0] : "picker";
};
